import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {

  }

  private getQueryParams(state: RouterStateSnapshot) {
    return state.url !== '/' ? { returnUrl: state.url } : null;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const auth = this.authService.authInfoBehavior.value;
    if (!auth) {
      this.router.navigate(['/login'], { queryParams: this.getQueryParams(state) });
      return false;
    }

    const allowedRoles = route.data.roles as string[] | null | undefined;

    if (allowedRoles && allowedRoles.length > 0) {
      for (let allowedRole of allowedRoles) {
        if (auth.roles.includes(allowedRole)) {
          return true;
        }
      }
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.getQueryParams(state) } });
      return false;
    }

    return true;
  }

}
